const Bitrix24 = () => {
  return <span className="bitrix24">Bitrix24</span>
}

export default Bitrix24
